import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'
import placeholder from '../assets/placeholder_elementary.png'

const Pose = ApplicationRecord.extend({
  static: {
    jsonapiType: 'poses',
  },
  attrs: {
    extension: attr(),
    selectedForYearbook: attr(),
    // Read-only: the official yearbook pose of record (Pose#is_yearbook_pose).
    // Used by the senior yearbook-selection step to pre-highlight an existing choice.
    isYearbookPose: attr({ persist: false }),
    url: attr(),
    index: attr(),
    createdAt: attr(),
    type: attr({ persist: false }),
    updatedAt: attr(),
    imageUrl: attr(),
    rotatedUrl: attr(),
    folder: attr(),
    rotatedWatermarkUrl: attr(),
    imageFileName: attr(),
    number: attr(),
    watermarkUrl: attr(),
    studentImage: belongsTo(),
    sheets: hasMany(),
    addonSheets: hasMany(),
  },
  methods: {
    image() {
      let res = placeholder

      if (this.imageUrl) res = this.imageUrl
      else if (this.watermarkUrl) res = this.watermarkUrl

      return res
    },
    watermark() {
      if (this.watermarkUrl) return this.watermarkUrl

      return placeholder
    },
    isPNG() {
      return this.imageUrl && this.imageUrl.toLowerCase().includes('.png');
    }
  },
})

export default Pose
